import axios from 'axios'
import { endpoint } from '../config'

export function SET_MEETINGS() {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/meetings`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.meetings)
            })
        })
    }
}

export function SET_MEETING_BY_ID(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/meetings/${_id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.meeting)
            })
        })
    }
}

export function ATTEND_MEETING(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/meetings/${_id}/attend`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.meeting)
            })
        })
    }
}

export function LEAVE_MEETING(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/meetings/${_id}/cancel-attend`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.meeting)
            })
        })
    }
}